import { NavigationWithModalProvider } from './NavigationWithModalProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'shared/src/constant';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { enableScreens } from 'react-native-screens';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { ToastProvider } from 'shared/src/component';
import { ADSContext, useScreenSize } from '@banhala/ui-kit';
import { ThirdPartyInitProvider } from './provider/ThirdPartyInitProvider';
import { UserExperimentalGroupSetComponent } from 'shared/src/context/UserContext';
import { useMemo } from 'react';
import { queryStringToObject } from './utils/queryStringToObject';

import 'swiper/css';
import 'swiper/css/autoplay';
enableScreens();
export type AppProps = {
  screen: string;
  instanceId?: string;
  params?: string | number;
  extras?: string;
  first_page_rendering?: string;
};
export const DESKTOP_MAX_WIDTH = 600;

function App() {
  const { width } = useScreenSize();

  const props = useMemo<AppProps>(() => {
    // return location;
    return queryStringToObject(window.location.href) as AppProps;
  }, []);

  return (
    <SafeAreaProvider>
      <GestureHandlerRootView>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <ADSContext.Provider
            value={{
              contentWidth: Math.min(width, DESKTOP_MAX_WIDTH),
              fontWeight: {
                regular: 'Pretendard-Regular',
                bold: 'Pretendard-SemiBold',
              },
              goodsBasePath: 'https://m.a-bly.com/goods/',
            }}
          >
            <ThirdPartyInitProvider>
              <UserExperimentalGroupSetComponent>
                <NavigationWithModalProvider {...props} />
              </UserExperimentalGroupSetComponent>
            </ThirdPartyInitProvider>
          </ADSContext.Provider>
          <ToastProvider />
        </QueryClientProvider>
      </GestureHandlerRootView>
    </SafeAreaProvider>
  );
}

export default App;
